export enum PropostaEstats {
  PENDENT = 1,
  ACCEPTADA = 0,
  DESESTIMADA = 2,
  PENDENT_VALIDACIO = 3,
  PREPROPOSTA = 4
}
